function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  d: "M53.396 64c-36.388 0-42.648-6.165-46.388-9.85l-.288-.283C2.47 49.707 0 42.552 0 31.997c0-10.552 2.47-17.704 6.72-21.866l.29-.285C10.75 6.165 17.008 0 53.396 0h133.208c36.388 0 42.646 6.165 46.386 9.846l.29.285c4.25 4.162 6.72 11.314 6.72 21.867 0 10.554-2.47 17.709-6.72 21.869l-.288.283c-3.74 3.685-10 9.85-46.388 9.85z"
});

var SvgButtonBubble = function SvgButtonBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 64",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button-bubble.21668613.svg";
export { ForwardRef as ReactComponent };